<template>
  <div class="upload">
    <div
      class="upload__overlay"
      @click="onFile"
    />
    <input
      type="file"
      ref="input"
      v-bind="$attrs"
      class="upload__input"
      @input="onChange"
    >
    <BaseIcon
      icon="upload-photo"
      class="upload__icon"
    />
    <p class="upload__text">+ Загрузить фотографию</p>
  </div>
</template>

<script>
import BaseIcon from '@/components/Base/BaseIcon'

export default {
  name: 'BaseUploadImage',
  components: {
    BaseIcon
  },
  emits: ['add'],
  methods: {
    onChange (event) {
      this.$emit('add', event)
    },
    onFile () {
      this.$refs.input.click()
    }
  }
}
</script>

<style lang="scss" scoped>
$brand-color:                     #FF7A00 !default;
$input-color:                     #262626 !default;

.upload {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  position: relative;

  &__overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  &__input {
    display: none;
  }
  &__icon {
    width: 40px;
    color: $brand-color;
  }
  &__text {
    margin-left: 14px;
  }
}
</style>
